vue
<template>
  <div class="board-members" id="members">
    <h1>Our Board Members</h1>
    <span class="mb-2">Our board members bring a wealth of expertise, visionary leadership, and a commitment to driving <br>innovation and excellence across every aspect of the organization.</span>
    <div class="members-container">
      <div class="member-card" v-for="member in members" :key="member.id">
        <img :src="member.picture" :alt="member.name" class="member-picture" />
        <h2 class="member-name">{{ member.name }}</h2>
        <p class="member-description">{{ member.description }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BoardMembers',
  data() {
    return {
      members: [
        {
          id: 1,
          name: 'Rashid Khan',
          description: 'Founder & CEO',
          picture: require('@/assets/images/members/rashid.jpg')
        },
        {
          id: 2,
          name: 'Bruce Beasley',
          description: 'Chief Emergency Compliance Officer and Advisory Board Member',
          picture: require('@/assets/images/members/bruce.jpg')
        },
        {
          id: 3,
          name: 'Shafaat Hashmi',
          description: 'Chief Growth Officer and Advisory Board Member',
          picture: require('@/assets/images/members/shafaat.jpg')
        },
        {
          id: 4,
          name: 'Andrew Stark',
          description: 'Chief Risk Officer and Advisory Board Member',
          picture: require('@/assets/images/members/andrew.jpg')
        },
        {
          id: 5,
          name: 'Shan Rahman',
          description: 'Chief Technology Officer',
          picture: require('@/assets/images/members/shan.jpg')
        }
      ]
    };
  }
};
</script>

<style scoped>
.board-members {
  text-align: center;
  padding: 120px 0 120px 0;
  background-color: #f9f9f9;
}

.members-container {
  margin-top: 50px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 20px;
}

.board-members h1{
  font-size: 36px;
  color: black;
}

.board-members span{
  font-size: 18px;
  color: black;
}

.member-card {
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  padding: 15px;
  width: 200px;
  transition: transform 0.3s ease-in-out; /* Adds a smooth animation */
}

.member-card:hover {
  transform: scale(1.3); /* Scale the element by 10% */
}

.member-picture {
  width: 100%;
  border-radius: 8px;
  filter: grayscale(100%); /* Makes the image greyscale */
  transition: filter 0.3s ease-in-out, transform 0.3s ease-in-out; /* Smooth transition for filter and transform */
}

.member-card:hover .member-picture {
  filter: grayscale(0%); /* On hover, turn the image to full color */
  transform: scale(1.05); /* Slightly scale up the image for a subtle zoom effect */
}

.member-name {
  font-size: 1.2em;
  margin: 10px 0 5px 0;
}

.member-description {
  color: #555;
}
</style>